
export const navigationLinks = [
  {
    link: "/",
    icon: <i className=" text-[20px] text-white bx bxs-home-alt-2"></i>,
    description: "Dashboard",
  },
  {
    link: "/notification",
    icon: <i className="text-[20px] text-white bx bx-history"></i>,
    description: "Maps",
  },
  // {
  //   link: "/add-friends",
  //   icon: <i className="bx bx-money-withdraw text-white text-[20px]"></i>,
  //   description: "Friends",
  // },
  {
    link: "/profile",
    icon: <i className=" text-[20px] text-white bx bxs-user-circle"></i>,
    description: "Profile",
  },
];
